// 2024 Topps Chrome Star Wars Costco Exclusive
// =============================================================================
// The Costco Super Box exclusive for 2024 Chrome: a 50-card exclusive Chrome
// set plus the 10 Heads Up Die Cuts (CDC-1..CDC-10, continued as CDC-11..20
// in the 2025 Costco set).
// The 50 cards carry their OWN printed numbers, which differ from the main
// 2024 Chrome base for part of the run (e.g. Costco #68 is Darth Vader where
// the flagship #68 is Reva) — specimen-confirmed (eBay item 256754223104,
// Costco Reva printed #70).
// Parallels: Refractor (unnumbered; specimens on eBay), Red/Blue /10 and
// Red /5 (TCDB sid 463847 SN10 / sid 462082 SN5 — single-source as of
// 2026-09-05, no specimen found yet; flagged, kept because a missing slot
// blocks any holder while an extra one is harmless).
// The die-cuts print a position label ("X of 10", partly misprinted by Topps)
// — that is a set position, not a serial, so no serial slot.
// Sources: TCDB sid 462081/465601/462082/463847/463846 + jedicards.com
// 2024 Topps Chrome Costco Exclusives (independent; lists match card-for-card).
// =============================================================================

export const SETS = [
  {
    id: "costco-exclusive",
    type: "base",
    title: "COSTCO EXCLUSIVE",
    parallels: [
        { id: "refractor", name: "Refractor", print_run: null, color: "#c8d8f0" },
        { id: "red-blue-refractor", name: "Red/Blue Refractor", print_run: 10, color: "#b060ff" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
      ],
    cards: [
        { n: "1", name: "Ahsoka Tano" },
        { n: "3", name: "Sabine Wren" },
        { n: "4", name: "Grand Admiral Thrawn" },
        { n: "5", name: "Baylan Skoll" },
        { n: "7", name: "Cassian Andor" },
        { n: "8", name: "Mon Mothma" },
        { n: "9", name: "Luthen Rael" },
        { n: "14", name: "Dedra Meero" },
        { n: "18", name: "Saw Gerrera" },
        { n: "20", name: "Boba Fett" },
        { n: "21", name: "Fennec Shand" },
        { n: "22", name: "The Mandalorian" },
        { n: "23", name: "Grogu" },
        { n: "38", name: "Moff Gideon" },
        { n: "39", name: "Bo-Katan Kryze" },
        { n: "40", name: "The Armorer" },
        { n: "44", name: "Greef Karga" },
        { n: "68", name: "Darth Vader" },
        { n: "69", name: "Obi-Wan Kenobi" },
        { n: "70", name: "Reva" },
        { n: "71", name: "Princess Leia" },
        { n: "72", name: "Luke Skywalker" },
        { n: "73", name: "Uncle Owen" },
        { n: "74", name: "Aunt Beru" },
        { n: "80", name: "The Grand Inquisitor" },
        { n: "101", name: "K-2SO" },
        { n: "102", name: "Han Solo" },
        { n: "106", name: "Lando Calrissian" },
        { n: "107", name: "Chewbacca" },
        { n: "108", name: "R2-D2" },
        { n: "109", name: "C-3PO" },
        { n: "110", name: "BB-8" },
        { n: "112", name: "Rey" },
        { n: "113", name: "Finn" },
        { n: "114", name: "Poe Dameron" },
        { n: "115", name: "Kylo Ren" },
        { n: "117", name: "Supreme Leader Snoke" },
        { n: "118", name: "Jabba The Hutt" },
        { n: "119", name: "Jyn Erso" },
        { n: "121", name: "Admiral Ackbar" },
        { n: "123", name: "Wicket W. Warrick" },
        { n: "128", name: "Qui-Gon Jinn" },
        { n: "129", name: "Count Dooku" },
        { n: "130", name: "Padmé Amidala" },
        { n: "131", name: "Emperor Palpatine" },
        { n: "134", name: "Maz Kanata" },
        { n: "135", name: "General Grievous" },
        { n: "138", name: "Mace Windu" },
        { n: "140", name: "Yoda" },
        { n: "150", name: "Qi'ra" },
    ],
  },
  {
    id: "heads-up-die-cuts",
    type: "insert",
    title: "HEADS UP DIE CUTS",
    parallels: [],
    cards: [
        { n: "CDC-1", name: "Darth Vader" },
        { n: "CDC-2", name: "Luke Skywalker" },
        { n: "CDC-3", name: "Han Solo" },
        { n: "CDC-4", name: "Boba Fett" },
        { n: "CDC-5", name: "Ahsoka Tano" },
        { n: "CDC-6", name: "Princess Leia" },
        { n: "CDC-7", name: "Mace Windu" },
        { n: "CDC-8", name: "Chewbacca" },
        { n: "CDC-9", name: "C-3PO" },
        { n: "CDC-10", name: "The Mandalorian" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
